<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="5">
                    <input type="text" placeholder="Version App" v-model="searchVersion" class="form-control"/>
                </CCol>
                <CCol sm="5" style="padding-left: 4px;padding-right:4px">
                    <input type="text" placeholder="Type OS" v-model="searchOs" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Version App</label>
                        <input 
                            v-if="tipe == 'C'"
                            class="form-control" 
                            v-model.trim="$v.versi.$model"
                            :class="{ 'is-invalid':$v.versi.$error, 'is-valid': !$v.versi.$invalid }"
                            placeholder="Version" 
                            type="text"
                        />
                        <input 
                            v-else
                            disabled
                            style="background-color:whitesmoke"
                            class="form-control" 
                            v-model.trim="$v.versi.$model"
                            :class="{ 'is-invalid':$v.versi.$error, 'is-valid': !$v.versi.$invalid }"
                            placeholder="Version" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tipe OS</label>
                        <model-select :options="dataOS"
                            v-if="tipe == 'C'"
                            class="form-control model-select"
                            v-model.trim="$v.selectedOs.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedOs.$error, 'is-valid select-valid': !$v.selectedOs.$invalid }"
                            placeholder="Pilih Tipe OS">
                        </model-select>
                        <model-select :options="dataOS"
                            v-else
                            :isDisabled="true"
                            class="form-control model-select"
                            v-model.trim="$v.selectedOs.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedOs.$error, 'is-valid select-valid': !$v.selectedOs.$invalid }"
                            placeholder="Pilih Tipe OS">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Jenis Urgensi</label>
                        <model-select :options="dataUrgensi"
                            class="form-control model-select"
                            v-model.trim="$v.selectedUrgensi.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedUrgensi.$error, 'is-valid select-valid': !$v.selectedUrgensi.$invalid }"
                            placeholder="Pilih Jenis Urgensi">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12">
                        <label>Penjelasan</label>
                        <vue-editor 
                            v-model.trim="$v.alasan.$model"
                            :class="{ 'is-invalid select-invalid':$v.alasan.$error, 'is-valid select-valid': !$v.alasan.$invalid }"
                            :editorToolbar="customToolbar"
                            placeholder="Masukkan Penjelasan"
                        ></vue-editor>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="tipe == 'U'" @click="deleteModal = true" class="btn btn-delete mr-2">
                    <span v-if="loadingDelete == false">Hapus</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
                <CButton @click="submitForm('null')" class="btn btn-edit-submit">
                    <span v-if="loading == false">Simpan</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
    <CModal
        size="sm"
        :centered="true"
        title="Info Delete"
        color="danger"
        :show.sync="deleteModal"
        >
        <p>Apakah anda yakin ingin menghapus data {{versi}}?</p>
        <CRow>
            <CCol sm="6">
                <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
            </CCol>
            <CCol sm="6">
                <CButton @click="submitForm('D')" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
            </CCol>
        </CRow>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import Tables from '../../../component/tableVersion'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { VueEditor } from "vue2-editor";
export default {
    components: {
        ModelSelect,
        Tables,
        VueEditor
    },
    mixins: [validationMixin],
    validations: {
        versi: {
            required
        },
        alasan: {
            required
        },
        selectedUrgensi: {
            value: {
                required
            },
            text: {
                required
            }
        },
        selectedOs: {
            value: {
                required
            },
            text: {
                required
            }
        }
    },
    data() {
        return {
            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['OS', 'Version', 'Urgensi', 'Penjelasan', 'Action'],
            dataTd: ['os', 'versi', 'urgent', 'alasan', 'action'],
            styleTable: ['75px', '75px', '100px', '175px', '75px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            loadingDelete: false,
            alertMess: '',
            currentAlertCounter: 0,
            deleteModal: false,

            // data model
            tipe: 'C',
            alasan: '',
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{ list: "bullet" }]
            ],
            versi: '',
            dataOS: [],
            dataUrgensi: [],
            selectedOs: {
                value: '',
                text: ''
            },
            selectedUrgensi: {
                value: '',
                text: ''
            },
            unix: 0,

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchVersion: '',
            searchOs: '',

            // error
            errorMessage: '',
            flagSearch: false
            
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchVersion() {
            this.flagSearch = true
        },
        searchOs() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    computed: {
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                alasan: "",
                limit: this.size,
                os: this.searchOs,
                pageIn: this.page,
                urgent: "",
                versi: this.searchVersion
            }
            DataApi.post("version/mobile", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchVersion = ''
            this.searchOs = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        getDataOS() {
            this.dataOS = [
                { value: 'ANDROID', text: 'ANDROID' },
                { value: 'IOS', text: 'IOS' },
            ]
        },
        getDataUrgensi() {
            this.dataUrgensi = [
                { value: '0', text: 'Tidak Wajib Update' },
                { value: '2', text: 'Dianjurkan Untuk Update' },
                { value: '1', text: 'Wajib Update' },
            ]
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.alasan = ''
                this.selectedOs.value = ''
                this.selectedOs.text = ''
                this.selectedUrgensi.value = ''
                this.selectedUrgensi.text = ''
                this.versi = ''

                this.getDataOS()
                this.getDataUrgensi()
                this.tipe = 'C'
                this.$v.$reset()
            }
        },
        goSave(val) {
            let tipe = ''
            if(val == 'D') {
                tipe = 'D'
            } else {
                tipe = this.tipe
            }
            let payload = {
                alasan: this.alasan,
                os: this.selectedOs.value,
                tipe: tipe,
                unix: this.unix,
                urgent: this.selectedUrgensi.value,
                versi: this.versi
            }
            DataApi.post("version/mobile/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.deleteModal = false
                this.moving()
                this.loading = false
                this.loadingDelete = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.alasan = generate.alasan
            this.versi = generate.versi
            this.unix = generate.unix

            let tempOs = generate.os
            let dataOs = this.dataOS
            var j = 0
            for (let j = 0; j < dataOs.length; j++) {
                if(tempOs == dataOs[j].value) {
                    this.selectedOs.text = dataOs[j].text
                    this.selectedOs.value = dataOs[j].value
                }
            }

            let tempUrgensi = generate.urgent
            let dataUrgensi = this.dataUrgensi
            var i = 0
            for (let i = 0; i < dataUrgensi.length; i++) {
                if(tempUrgensi == dataUrgensi[i].value) {
                    this.selectedUrgensi.text = dataUrgensi[i].text
                    this.selectedUrgensi.value = dataUrgensi[i].value
                }
            }

            this.tipe = 'U'
            this.moving()
        },
        submitForm(val) {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave(val)
                if(val == 'D') {
                    this.loadingDelete = true
                } else {
                    this.loading = true
                }
            }
        },

    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataUrgensi()
        this.getDataOS()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-delete {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid red;
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-delete:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid red;
    background-color: red;
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
</style>
